<mat-list>
    <mat-list-item
        *ngFor="let leader of leaderboards"
        [class.user-line]="loggedUserId == leader.userId || userIsInTheGroup(leader.groupId)"
    >
        <div
            mat-line
            fxLayout="row"
            fxLayoutAlign="space-between start"
            [matTooltip]="tooltipDesc(leader)"
            #tooltip="matTooltip"
        >
            <mat-divider></mat-divider>
            <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start center" fxFlex class="leader-infos">
                <span fxLayout="row" fxLayoutAlign="center center" class="position">
                    {{ leader.position + 1 }}
                </span>
                <ngx-avatar
                    mat-card-avatar
                    [src]="leader.userSummary?.avatarUrl || null"
                    [name]="
                        leader.userSummary
                            ? leader.userSummary.name + ' ' + leader.userSummary.surname
                            : leader.groupSummary?.name
                    "
                    [size]="40"
                >
                </ngx-avatar>
                <div class="leader-name text-truncate" fxLayout="row" fxLayoutAlign="start center">
                    {{
                        leader.userSummary
                            ? leader.userSummary.name + " " + leader.userSummary.surname
                            : leader.groupSummary?.name
                    }}
                </div>
            </div>
            <div class="points" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
                <mat-icon>grade</mat-icon>
                {{ leader.points }}pts
            </div>
        </div>
    </mat-list-item>
</mat-list>
